import { render, staticRenderFns } from "./x_swiper.vue?vue&type=template&id=179a1fb0&scoped=true"
import script from "./x_swiper.vue?vue&type=script&lang=js"
export * from "./x_swiper.vue?vue&type=script&lang=js"
import style0 from "./x_swiper.vue?vue&type=style&index=0&id=179a1fb0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a1fb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mdn_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179a1fb0')) {
      api.createRecord('179a1fb0', component.options)
    } else {
      api.reload('179a1fb0', component.options)
    }
    module.hot.accept("./x_swiper.vue?vue&type=template&id=179a1fb0&scoped=true", function () {
      api.rerender('179a1fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/component/x_swiper.vue"
export default component.exports